import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.css'],
  standalone: true,
})
export class SvgIconComponent {
  readonly icon = input.required<string>();
  readonly width = input<number>();
  readonly height = input<number>();
  readonly size = input<number | undefined>(24);
  readonly viewBox = input<string>();
  readonly fill = input<string>();
  readonly class = input<string>();

  // Either dimension missing falls back to `size` for both, keeping the icon
  // square instead of stretching a partially specified box.
  readonly effectiveWidth = computed(() =>
    !this.width() || !this.height() ? this.size() : this.width(),
  );
  readonly effectiveHeight = computed(() =>
    !this.width() || !this.height() ? this.size() : this.height(),
  );
}
